import { clsx, type ClassValue } from "clsx"
import { extendTailwindMerge } from "tailwind-merge"

const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      'font-size': [
        {
          text: [
            'dash-nano', 'dash-micro', 'dash-caption', 'dash-caption-lg',
            'dash-body', 'dash-title', 'dash-metric-sm', 'dash-metric',
            'dash-metric-lg', 'dash-metric-xl', 'dash-page',
            'wn-2xs', 'wn-xs', 'wn-sm', 'wn-md', 'wn-base', 'wn-lg',
            'wn-xl', 'wn-2xl', 'wn-3xl', 'wn-4xl', 'wn-5xl',
          ],
        },
      ],
      'font-weight': [
        { font: ['wn-normal', 'wn-medium', 'wn-semibold', 'wn-bold', 'wn-extrabold', 'wn-black'] },
      ],
      'leading': [{ leading: ['wn-none', 'wn-tight', 'wn-snug', 'wn-normal', 'wn-relaxed'] }],
      'tracking': [
        { tracking: ['wn-tighter', 'wn-tight', 'wn-normal', 'wn-wide', 'wn-wider', 'wn-widest'] },
      ],
      'shadow': [{ shadow: ['card', 'raised', 'bar', 'overlay', 'brand'] }],
      'rounded': [{ rounded: ['xs', '2xs'] }],
    },
  },
})

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function getAvatarColor(seed: string) {
  let hash = 0;
  for (let i = 0; i < seed.length; i++) {
    hash = seed.charCodeAt(i) + ((hash << 5) - hash);
  }

  const hue = Math.abs(hash % 360);
  const saturation = 75;
  const lightness = 90;

  return `hsl(${hue}, ${saturation}%, ${lightness}%)`;
}
